import React, { useState, useEffect, useContext } from 'react';

import { PackageContext } from '../../../context/packageContext';

import FarmItems from './FarmItems';
import PackageCard from '../PackageCard';

import Cereal from '../../../images/cereals.png';
import Tubers from '../../../images/tubers.png';
import Veggies from '../../../images/vegetable.png';

const FarmPackage = ({
  handleSelection,
  selectedPackage,
  setUnexpectedError,
  setLoading,
  runPackage,
  firstName
}) => {
  const { getPackages } = useContext(PackageContext);

  const [packages, setPackages] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (runPackage)
      (async () => {
        setLoading(true);
        try {
          let response = await getPackages();
          if (mounted) {
            if (response.code === 200) {
              setPackages(response.data);
            } else {
              setUnexpectedError('Unexpected server Error!');
            }
          }
        } catch (error) {
          setUnexpectedError('Unexpected Network Error!');
        }
        setLoading(false);
      })();
    return () => (mounted = false);
  }, [getPackages, runPackage, setLoading, setUnexpectedError]);

  return (
    <FarmItems
      title="start with the right farming package for you."
      subtitle="Choose your farm experience"
      subText
      salute="Hi"
      name={firstName}
    >
      {packages.map(_package => (
        <div className="w-full md:w-1/3 md:pr-4 mb-6 md:mb-0" key={_package._id}>
          <PackageCard
            title={_package.title}
            img={_package.level === 1 ? Cereal : _package.level === 2 ? Tubers : Veggies}
            click={() => handleSelection(_package)}
            selected={selectedPackage && selectedPackage._id === _package._id}
            name={
              _package.level === 1 ? 'Soya Beans' : _package.level === 2 ? 'Sweet Potato' : 'Ginger'
            }
            status={_package.status}
          />
        </div>
      ))}
    </FarmItems>
  );
};

export default FarmPackage;
